import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';
import { ReactNode } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { createSingleChoice } from '@flipster/react/design-system/chip';

import { TradFiCategory, marketListBunja } from './state';

const Choice = createSingleChoice<TradFiCategory>();

const categoryLabels: Record<TradFiCategory, ReactNode> = {
  all: <FormattedMessage id='Autogen_common.r251126.s_All' />,
  preIpo: <FormattedMessage id='Market.r260624.Preipo' />,
  stock: <FormattedMessage id='Market.r260624.Stock' />,
  etf: <FormattedMessage id='Market.r260624.Etf' />,
  commodity: <FormattedMessage id='Market.r260624.Commodity' />,
};

export const TradFiCategoryChips = () => {
  const { tradFiCategoryAtom, availableTradFiCategoriesAtom } = useBunja(marketListBunja);
  const [category, setCategory] = useAtom(tradFiCategoryAtom);
  const categories = useAtomValue(availableTradFiCategoriesAtom);

  return (
    <Choice value={category} onChange={setCategory} css={{ px: 16, pb: 12 }}>
      {categories.map((value) => (
        <Choice.Chip key={value} value={value} label={categoryLabels[value]} />
      ))}
    </Choice>
  );
};
